<template>
  <div>
    <div v-for="(d, dind) in object.users"
         :key="`dind-${dind}`">
      {{ d.full_name }}
    </div>
    <div v-if="!object.users.length && object.user">{{ object.user.full_name }}</div>
  </div>
</template>

<script setup>
defineProps({
  object: {
    type: Object
  }
})
</script>
